















import Vue from "vue";
import { Data, Methods, Computed, Props } from "./types";
import "@/components/icons";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "ReportPreviousTime",
  props: {
    reportPreviousTimeIconName: {
      type: String,
      required: true
    },
    reportPreviousTimeBody: {
      type: Number,
      default: 0
    }
  },
  computed: {
    iconClasses() {
      return {
        "reportPreviousTime__icon--down":
          this.reportPreviousTimeIconName === "Down"
      };
    }
  }
});
